import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { PartyState } from './types';
import { RootState } from '@/types';

export const state: PartyState = {
    data: {
      party: undefined,
      comments: undefined,
      contacts: undefined,
      attachments: undefined,
    },
    loading: true,
    error: false,
    commentsError: false,
    commentsLoading: true,
    contactsError: false,
    contactsLoading: true,
    attachmentsError: false,
    attachmentsLoading: true,
};

const namespaced: boolean = true;

export const party: Module<PartyState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
